var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 2.5C0 1.39688 0.95293 0.5 2.125 0.5H14.875C16.0471 0.5 17 1.39688 17 2.5V12.5C17 13.6031 16.0471 14.5 14.875 14.5H2.125C0.95293 14.5 0 13.6031 0 12.5V2.5ZM10.7512 5.82812C10.6018 5.62187 10.3561 5.5 10.0938 5.5C9.83145 5.5 9.58242 5.62187 9.43633 5.82812L6.54766 9.81563L5.66777 8.78125C5.51504 8.60312 5.28594 8.5 5.04688 8.5C4.80781 8.5 4.57539 8.60312 4.42598 8.78125L2.30098 11.2812C2.1084 11.5063 2.07188 11.8156 2.20469 12.075C2.3375 12.3344 2.61641 12.5 2.92188 12.5H6.10938H7.17188H14.0781C14.3736 12.5 14.6459 12.3469 14.782 12.1C14.9182 11.8531 14.9016 11.5562 14.7355 11.3281L10.7512 5.82812ZM3.71875 5.5C4.14144 5.5 4.54682 5.34196 4.8457 5.06066C5.14459 4.77936 5.3125 4.39782 5.3125 4C5.3125 3.60218 5.14459 3.22064 4.8457 2.93934C4.54682 2.65804 4.14144 2.5 3.71875 2.5C3.29606 2.5 2.89068 2.65804 2.5918 2.93934C2.29291 3.22064 2.125 3.60218 2.125 4C2.125 4.39782 2.29291 4.77936 2.5918 5.06066C2.89068 5.34196 3.29606 5.5 3.71875 5.5Z",
    fill: "#FF8C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.2a48796a85ab639a4f522bb56395269d.svg";
export { ForwardRef as ReactComponent };